// hours in milliseconds: 1000 * 60 * 60
import {ITimerCountDownProps} from "./count-down-timer/count-down-timer";

export const DAYS_MS = (1000 * 60 * 60 * 24);

export const HOURS_MS = 3600000;

// minutes in milliseconds: 1000 * 60
export const MIN_MS = 60000;

/**
 * get server date parameters from hidden fields (in master page)
 */
export const getServerDate = () => {
    const day = Number(document.getElementById('current-day')?.innerText) || 1;
    const month = Number(document.getElementById('current-month')?.innerText) || 1;
    const year = Number(document.getElementById('current-year')?.innerText) || 0;
    const hour = Number(document.getElementById('current-hour')?.innerText) || 0;
    const minute = Number(document.getElementById('current-minute')?.innerText) || 0;
    const sec = Number(document.getElementById('current-sec')?.innerText) || 0;

    return new Date(year, month - 1, day, hour, minute, sec).getTime();
};

/**
 * add 0 to the left of the number (if needed)
 */
export const twoDigits = (number: number) => {
    let result = parseInt(number + '').toString();
    if (result.length < 2) {
        result = '0' + result;
    }

    return result;
};

/**
 * difference's hour -> string
 */
export const getHours = (difference: number) => {
    const hours = difference / HOURS_MS;
    return twoDigits(hours);
};

/**
 * difference's minutes -> string
 */
export const getMinutes = (difference: number) => {
    const minutes = (difference % HOURS_MS) / MIN_MS;
    return twoDigits(minutes);
};

/**
 * difference's seconds -> string
 */
export const getSeconds = (difference: number) => {
    const seconds = (difference % HOURS_MS % MIN_MS) / 1000;
    return twoDigits(seconds);
};

export const getTimerCounterDataFromHtml = (timerId: string) : ITimerCountDownProps| undefined => {

    var sTimer: ITimerCountDownProps |undefined;
    const subscriptionTimer_Obj = document.getElementById(timerId);
    if(subscriptionTimer_Obj){

        const dataSaleEndDate = subscriptionTimer_Obj.getAttribute("data-sale-end-date") ?? '';
        let countDownTime;
        try{
            countDownTime= new Date(dataSaleEndDate);
            //Eastern Standard Time (EST). UTC -5. now 1 hour behind New York
            //countDownTime.setHours(countDownTime.getHours() - 1);
        }
        catch(ex){
            console.log('try parse countDownTime(' + dataSaleEndDate + '): ',ex);
        }
        if(countDownTime) {
            sTimer = {
                timerType: subscriptionTimer_Obj.getAttribute("data-type") ?? 'general',
                dataClass: subscriptionTimer_Obj.getAttribute("data-class") ?? undefined,
                dataClassEx: subscriptionTimer_Obj.getAttribute("data-class-ex") ?? undefined,
                expiredWhenNumber: countDownTime.getTime()
            }
        }
    }

    return  sTimer;
}